module.exports = __webpack_public_path__ + "fonts/7cfcca0c-7dc0-43f9-94ae-59c7be593329.b0bf851.eot";